import React from 'react'
import Layout from '../../components/layout/Layout'
import ActiveUsersTable from '../../elements/tables/users/ActiveUsersTable'

export default function ActiveUsers() {
  return (
    <div>
      <Layout>
        <ActiveUsersTable />
      </Layout>
    </div>
  )
}
